import { useRef } from 'react';

import { ActionIcon } from '@mantine/core';
import { TimeInput } from '@mantine/dates';
import { IconClock } from '@tabler/icons-react';

export const convertToTimeString = (val: number) => {
  const hoursString = val.toString().padStart(2, '0');
  return `${hoursString}:00`;
};

const CustomTimePicker = (props: any) => {
  const ref = useRef<HTMLInputElement>(null);

  const pickerControl = (
    <ActionIcon variant={'subtle'} color={'gray'} onClick={() => ref.current?.showPicker()}>
      <IconClock size={16} stroke={1.5} />
    </ActionIcon>
  );

  return (
    <TimeInput
      {...props}
      withAsterisk={props.required}
      clearable={true}
      ref={ref}
      rightSection={pickerControl}
      minTime={convertToTimeString(props.min)}
      maxTime={convertToTimeString(props.max)}
    />
  );
};

export default CustomTimePicker;
